import React from 'react';
import { Link } from 'react-router-dom';

import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './NotFound.module.css';

const NotFound = () => {
    return (
        <div className='Page NotFound'>
            <Banner title="Page Not Found" custom={true}></Banner>
            <div className={styles.notFoundContent}>
                <h1 className={styles.notFoundTitle}>404</h1>
                <p className={styles.notFoundText}>Page Not Found</p>
                <Link to="/" className={styles.notFoundLink}>Home</Link>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default NotFound;